/*
 * BadgeType
 * @module components/Badges
 * @flow
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Badge } from '../';
import IconRoleMerchant from '@/icons/ic-role-merchant.png';
import IconTypeOrdinary from '@/icons/ic-type-ordinary.png';
import IconTypeActive from '@/icons/ic-type-active.png';
import IconTypeHonorary from '@/icons/ic-type-honorary.png';
import IconTypeMeritorius from '@/icons/ic-type-meritorious.png';

import messages from './messages';

export type BadgeTypeProps = {
  role: String,
  size?: number,
  type: 'GC' | 'AC' | 'HC' | 'MC',
};

/**
 * BadgeType React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {number} [props.isMerchant] - merchant role flag
 * @param {number} [props.size] - size
 * @param {string} [props.type] - user type
 * @example <caption>Simple usage</caption>
 * <BadgeType type="GC" size=35 role='M'/>
 * @returns {React.Node<*>} React-component
 */
export const BadgeType = ({ type, size, role }: BadgeTypeProps) => {
  const userType = role === 'M' ? 'MR' : type;
  const typeIconsMap = {
    AC: IconTypeActive,
    GC: IconTypeOrdinary,
    HC: IconTypeHonorary,
    MC: IconTypeMeritorius,
    MR: IconRoleMerchant,
  };

  return (
    <Badge
      icon={typeIconsMap[userType]}
      size={size}
      testid="badgetype"
      tooltip={<FormattedMessage {...messages[`type${userType}`]} />}
    />
  );
};
